var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g(_vm._b({staticClass:"inline-block",attrs:{"fill":"currentColor","viewBox":_vm.viewBox}},'svg',_vm.$attrs,false),_vm.$listeners),[_c('use',{attrs:{"href":("#" + _vm.src)}})])}
var staticRenderFns = []

export { render, staticRenderFns }